import React, { useState, useEffect } from "react";
import Menu from "./menu";
import SubMenu from "./SubMenu";
import ImageCros from "../assets/images/cross_img.png";
import LogoDarkAnimator from "./logoDarkAnimator";
import LogoWhiteAnimator from "./logoWhiteAnimator"
import About from "./about";
import Contact from "./contact";
import Vimeo from "@u-wave/react-vimeo";
import HomeLogoSlider from "./homePageSlider";

const HomePage = ({ projects, news, home }) => {


  const bannerVideo = home[0]?.fields?.bannerVideos
  const n = 1;
  const posts = bannerVideo?.sort(() => Math.random() - 0.5).slice(0, n);

  const [selectedPage, setSelectedPage] = useState({ fields: { title: "" } });
  const [detailPageShown, setDetailPageShown] = useState(false);
  const [detectScroll, setDetectScroll] = useState(false);

  console.log("home data", posts)

  window.addEventListener("scroll", (e) => {
    setDetectScroll(true);
  });

  console.log("Scroll Detect", detectScroll);

  const homeMenuChanged = (item) => {
    setSelectedPage(item);
    setDetailPageShown(false);
  };
  const homeMenuReset = (item) => {
    setSelectedPage({ fields: { title: "" } });
    setDetailPageShown(false);
  };
  const homePageShow = () => {
    setSelectedPage({ fields: { title: "" } });
  };

  const onDetailShown = (val) => {
    setDetailPageShown(val);
  };

  useEffect(() => { }, []);

  return (
    <div>
      {selectedPage.fields.title == "Showreel" && (
        <div className="show_reels_model">
          <div className="show_inner_reels">
            <button
              className="btn close_btn"
              onClick={() => setSelectedPage({ fields: { title: "" } })}
            >
              <img src={ImageCros} width="20px" height="20px" alt="" />
            </button>
            <div className="" style={{ width: "100%" }}>
              <Vimeo video="https://vimeo.com/738613188" autoplay />
            </div>
          </div>
        </div>
      )}
      {selectedPage.fields.title == "" && (
        <div className="home-bg-video-img">
          <video autoPlay loop muted playsInline>
            {posts != null && (
              <source src={`https:${posts[0]?.fields?.file?.url}`} type="video/mp4" />)}
          </video>
        </div>
      )}
      <div
        style={{
          backgroundColor:
            selectedPage.fields.title == "About" ||
              selectedPage.fields.title == "Contact"
              ? "#fff"
              : "",
        }}
        className={
          selectedPage.fields.title == "About" ||
            selectedPage.fields.title == "Contact"
            ? "homeBackground backgroundwhite"
            : "homeBackground background_black"
        }
      >
        <div className="container-fluid">
          <div className="homePage">
            <section className="section floating-wrap common-padding common-padding-lt-rt">
              <div className="main_logo">
                {selectedPage.fields.title == "About" ||
                  selectedPage.fields.title == "Contact" ? (
                  // <video src={LogoVideoBlack} width="210px" autoPlay />
                  <div onClick={() => setSelectedPage({ fields: { title: "" } })}> <LogoWhiteAnimator /></div>
                  // <img src={BlackLogo} width="210px" alt="logo" />
                ) : (
                  <div onClick={() => setSelectedPage({ fields: { title: "" } })}>
                    <LogoDarkAnimator />
                  </div>
                )}

              </div>
              <div className="container-fluid">
                <div className="row">
                  <div
                    className={
                      selectedPage.fields.title == ""
                        ? "col-lg-12"
                        : detailPageShown == false
                          ? "col-lg-3"
                          : "col-lg-2"
                    }
                  >
                    <div
                      className={
                        selectedPage.fields.title == ""
                          ? "main-menu big"
                          : detailPageShown == false
                            ? "main-menu medium"
                            : "main-menu small"
                      }
                      style={{
                        WebkitTransition: "all 1.5s",
                        transition: "all 1.5s",
                      }}
                    >
                      {selectedPage.fields.title != "" && (
                        <div className="back_btn" onClick={homeMenuReset}>
                          <div className="text">
                          </div>
                        </div>
                      )}
                      <div
                        className={
                          selectedPage.fields.title == "About" ||
                            selectedPage.fields.title == "Contact"
                            ? "navList"
                            : ""
                        }
                      >
                        <Menu
                          selectedLink={selectedPage}
                          links={[
                            { fields: { title: "Projects" } },
                            { fields: { title: "Showreel" } },
                            { fields: { title: "About" } },
                            // { fields: { title: "News" } },
                            { fields: { title: "Contact" } },
                          ]}
                          onChange={homeMenuChanged}
                        />
                      </div>
                      {selectedPage.fields.title == "" && (
                        <div className="mx-5" style={{ width: '40%', float: 'right' }} >
                          <HomeLogoSlider />
                        </div>
                      )}
                    </div>



                  </div>

                  <div
                    className={`${selectedPage.fields.title == ""
                      ? ""
                      : detailPageShown == false
                        ? "col-lg-9"
                        : "col-lg-10"
                      } all-detail-menus`}
                  >
                    {selectedPage.fields.title == "Projects" && (
                      <SubMenu
                        links={projects}
                        detailPageShown={detailPageShown}
                        onDetailShown={onDetailShown}
                        homeMenuReset={homeMenuReset}
                      />
                    )}
                    {/* {selectedPage.fields.title == "News" && (
                      <SubMenuNews
                        links={news}
                        detailPageShown={detailPageShown}
                        onDetailShown={onDetailShown}
                        homeMenuReset={homeMenuReset}
                      />
                    )} */}

                    {selectedPage.fields.title == "About" && (
                      <div className="text-white">
                        <About />
                      </div>
                    )}

                    {selectedPage.fields.title == "Contact" && (
                      <div className="text-white">
                        {" "}
                        <Contact />{" "}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
